import type {StateCreator} from 'zustand'

export type Range = {
  start: number
  end: number
}

export type InjectedContextlinesSliceOpts = {
  addInjectedContextLines: (range: Range) => void
}

export interface InjectedContextLinesSlice {
  injectedContextLinesActions: {
    addInjectedContextLines: (range: Range) => void
  }
}

export const createInjectedContextLinesSlice =
  ({
    addInjectedContextLines,
  }: InjectedContextlinesSliceOpts): StateCreator<InjectedContextLinesSlice, [['zustand/devtools', never]]> =>
  () => {
    return {
      injectedContextLinesActions: {
        addInjectedContextLines,
      },
    }
  }
